import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_INACTIVE_USER_TITLE,
	ONBOARDING_ERROR_INACTIVE_USER_DESCRIPTION,
	ONBOARDING_ERROR_INACTIVE_USER_CTA,
} from '../../../../constants/Copy';
import { ROUTE_LOGOUT } from '../../../../constants/Routes';

const DefaultInactiveUserError = (props) => (
	<FullPageMessage
		button={{
			onClick: () => props.history.push(ROUTE_LOGOUT),
			testValue: ROUTE_LOGOUT,
			text: ONBOARDING_ERROR_INACTIVE_USER_CTA,
		}}
		title={ONBOARDING_ERROR_INACTIVE_USER_TITLE}
		description={ONBOARDING_ERROR_INACTIVE_USER_DESCRIPTION}
	/>
);

DefaultInactiveUserError.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultInactiveUserError;
